import React from "react";

import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import { CardView } from "common/views/card/Card.view";
import { RowsView } from "common/views/rows/Rows.view";
import QueryComponent from "core/api/QueryComponent";
import { FragmentLayout } from "core/components/FragmentLayout";
import { IPanelProps, Panel } from "core/decorators/Panel";
import labelProvider from "./Badge.labels";
import BadgeListConfig from "./config/BadgeListPanelConfig";
import Badge from "./entities/Badge";
import * as badgeFragments from "./fragments/badge/displayFragments";

const { Labels } = labelProvider;

@Panel({
	id: "badge-list",
	configClass: BadgeListConfig,
	labelProvider
})
export default class BadgeListPanel extends React.Component<IPanelProps<BadgeListConfig>> {

	public render() {

		return (
			<QueryComponent entity={Badge} type="many" args={{issuedOnly: true}}>
				{
					({data, loading}) => {

						if (loading) {
							return <Loading />;
						}

						return data && data.length > 0 ? <RowsView viewKey="rows">{data.map(this.renderBadges)}</RowsView>
							 : <NonIdealState title={<Labels.BadgeEmptyTitle />} description={<Labels.BadgeEmptyDesc />} />;
					}
				}
			</QueryComponent>
		);
	}

	private renderBadges = (badge: Badge) => {
		const { config } = this.props;

		return (
			<CardView key={badge.id} viewKey={badge.pending ? "card" : "card-claimed"}>
				<FragmentLayout
							layout={config.badgeLayout}
							fragments={badgeFragments}
							props={{badge}}
				/>
			</CardView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/catalog/BadgeList.panel.tsx